import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CompanyShell } from "@/components/CompanyShell";
import { ScrollText, Loader2, ArrowLeft } from "lucide-react";

const ACTION_LABELS = {
  cv_import: "Import CV",
  update_settings: "Zmena nastavení",
  contact_candidate: "Kontaktovanie kandidáta",
  archive_candidate: "Archivácia kandidáta",
  unarchive_candidate: "Obnovenie kandidáta",
  anonymize_candidate: "Anonymizácia údajov",
};

export default function CompanyAudit() {
  const nav = useNavigate();
  const [logs, setLogs] = useState(null);

  useEffect(() => { api.get("/company/audit").then((r) => setLogs(r.data.logs)).catch(() => setLogs([])); }, []);

  return (
    <CompanyShell>
      <button onClick={() => nav("/company/settings")} className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 hover:text-slate-900 mb-4"><ArrowLeft size={16} /> Nastavenia</button>
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-2xl bg-slate-800 flex items-center justify-center"><ScrollText className="text-white" size={20} /></div>
        <div>
          <h1 className="font-head text-3xl font-bold tracking-tight">Audit log</h1>
          <p className="text-slate-600">História citlivých operácií vo vašej firme</p>
        </div>
      </div>

      {logs === null ? (
        <div className="flex justify-center py-20"><Loader2 className="animate-spin text-blue-700" /></div>
      ) : logs.length === 0 ? (
        <div className="mt-8 rounded-3xl border border-dashed border-slate-300 bg-white p-12 text-center text-slate-500">Zatiaľ žiadne záznamy.</div>
      ) : (
        <div className="mt-6 rounded-3xl bg-white border border-slate-200 shadow-sm overflow-hidden" data-testid="audit-list">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-left">
              <tr>
                <th className="px-5 py-3 font-semibold">Akcia</th>
                <th className="px-5 py-3 font-semibold hidden sm:table-cell">Cieľ</th>
                <th className="px-5 py-3 font-semibold">Dátum a čas</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {logs.map((l) => (
                <tr key={l.id} data-testid="audit-row">
                  <td className="px-5 py-3 font-medium text-slate-800">{ACTION_LABELS[l.action] || l.action}</td>
                  <td className="px-5 py-3 text-slate-500 hidden sm:table-cell">{l.target_type || "—"}{l.meta?.filename ? ` · ${l.meta.filename}` : ""}</td>
                  <td className="px-5 py-3 text-slate-500">{new Date(l.created_at).toLocaleString("sk-SK")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </CompanyShell>
  );
}
